import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

const labels = {
  0.5: "Terrible",
  1: "Bad",
  1.5: "Poor",
  2: "Okay",
  2.5: "Average",
  3: "Fine",
  3.5: "Nice",
  4: "Good",
  4.5: "Very good",
  5: "Excellent",
};

const tagOptions = {
  low: [
    "Driver was rude",
    "Vehicle was damaged",
    "Late arrival",
    "Rough driving",
    "Unprofessional",
    "Poor communication",
  ],
  mid: [
    "Decent service",
    "Average cleanliness",
    "Minor delay",
    "Helpful but slow",
  ],
  high: [
    "Driver was polite",
    "Vehicle in great condition",
    "Reached on time",
    "Smooth journey",
    "Highly professional",
  ],
};

const RatingModalBox = ({state, onClose}) => {
  const [value, setValue] = useState(4);
      const { vendorDriverCode, accidentVehicleCode, currentService } = state;
    console.log('vendorDriverCode, accidentVehicleCode, currentService', vendorDriverCode, accidentVehicleCode, currentService)
  
  const [hover, setHover] = useState(-1);
  const [selectedTags, setSelectedTags] = useState([]);
  const [incomingAccidentVehicleCode, setIncomingAccidentVehicleCode] = useState(null);
  const [incomingVendorDriverCode, setIncomingVendorDriverCode] = useState(null);
  console.log('incomingAccidentVehicleCode', incomingAccidentVehicleCode, incomingVendorDriverCode)

  const [feedback, setFeedback] = useState("");
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");

  const getTagsBasedOnRating = () => {
    if (value <= 2) return tagOptions.low;
    if (value <= 3.5) return tagOptions.mid;
    return tagOptions.high;
  };

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };
  
  useEffect(()=>{
     console.log("✅ vendorDriverCode", vendorDriverCode);
  console.log("✅ accidentVehicleCode", accidentVehicleCode);
  console.log("✅ currentService", currentService);
    setIncomingAccidentVehicleCode(state.accidentVehicleCode)
    setIncomingVendorDriverCode(state.vendorDriverCode)

  }, [state])

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/customersRating/${userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            rating: value,
            selectedOptions: selectedTags,
            message: feedback,
           accidentVehicleCode: incomingAccidentVehicleCode,
           vendorDriverCode: incomingVendorDriverCode,
          }),
        }
      );

      if (response.ok) {
        onClose?.(); // ✅ Call onClose before navigation
        navigate("/customer-activity");
      } else {
        const result = await response.json();
        alert(`Failed to submit rating: ${result.message || "Please try again."}`);
      }
    } catch (error) {
      console.error("Error submitting rating:", error);
      alert("An error occurred. Please try again later.");
    }
  };

  return (
    <div className="font-satoshi min-h-screen bg-white flex flex-col justify-between max-w-lg w-full mx-auto shadow border border-gray-200">
      {/* Header */}
      <div>
        <div className="flex justify-between items-center mb-4 bg-[#21A6E9] text-white px-6 py-4">
          <span className="text-sm font-semibold">Rate {currentService === "crane" ? "Crane" : "Recovery Van"} Service Experience</span>
          <button
            onClick={() => handleSubmit()}
            className="text-2xl font-bold leading-none"
          >
            &times;
          </button>
        </div>

        {/* Rating */}
        <div className="flex flex-col items-center mb-4">
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Rating
              name="hover-feedback"
              value={value}
              precision={0.5}
              onChange={(event, newValue) => {
                setValue(newValue);
                setSelectedTags([]); // reset tags when rating changes
              }}
              onChangeActive={(event, newHover) => {
                setHover(newHover);
              }}
              sx={{
                color: "#22ff00ff",
              }}
              emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
            />
            {value !== null && (
              <Box sx={{ ml: 2, color: "#21A6E9", fontWeight: "600" }}>
                {labels[hover !== -1 ? hover : value]}
              </Box>
            )}
          </Box>
        </div>

        {/* Tags */}
        <div className="px-4">
          <p className="text-center text-gray-800 font-medium mb-3">
            What went {value <= 3.5 ? "wrong" : "well"}?
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            {getTagsBasedOnRating().map((tag) => (
              <button
                key={tag}
                onClick={() => toggleTag(tag)}
                className={`px-4 py-1 rounded-full border text-sm font-medium transition-all duration-200 ${
                  selectedTags.includes(tag)
                    ? "bg-[#21A6E9] text-white border-[#21A6E9]"
                    : "bg-white text-black border-gray-400"
                }`}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Feedback box */}
      <div className="px-4 text-center text-sm text-gray-500 mt-6 pb-6">
        <textarea
          className="w-full h-32 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#21A6E9] resize-none mb-4"
          placeholder="Write your feedback here..."
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        ></textarea>
        <button
          className="w-full py-3 bg-[#21A6E9] hover:bg-[#1b91cc] text-white rounded-md text-lg font-semibold transition-all"
          onClick={handleSubmit}
        >
          SUBMIT
        </button>
      </div>
    </div>
  );
};

export default RatingModalBox;
